/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ free: NonNullable<unknown>, verein: NonNullable<unknown>, basic: NonNullable<unknown>, premium: NonNullable<unknown> }} Creditsmonthlydescription2Inputs */

const en_creditsmonthlydescription2 = /** @type {(inputs: Creditsmonthlydescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credits pay for your AI features and are topped up on the first of each month to ${i?.free} (Free), ${i?.verein} (Club), ${i?.basic} (Pro) or ${i?.premium} (Premium); cashback and extra credits are kept.`)
};

const de_creditsmonthlydescription2 = /** @type {(inputs: Creditsmonthlydescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Credits bezahlen deine KI-Funktionen und werden am Monatsersten auf ${i?.free} (Gratis), ${i?.verein} (Verein), ${i?.basic} (Pro) oder ${i?.premium} (Premium) aufgefüllt, Cashback und Extra-Credits bleiben dabei erhalten.`)
};

/**
* | output |
* | --- |
* | "Credits pay for your AI features and are topped up on the first of each month to {free} (Free), {verein} (Club), {basic} (Pro) or {premium} (Premium); cashba..." |
*
* @param {Creditsmonthlydescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsmonthlydescription2 = /** @type {((inputs: Creditsmonthlydescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsmonthlydescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsmonthlydescription2(inputs)
	return de_creditsmonthlydescription2(inputs)
});
export { creditsmonthlydescription2 as "creditsMonthlyDescription" }